/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminUserDtoPage } from '../../models/admin-user-dto-page';

export interface ListUsers$Params {
  query?: string;
  groupId?: string | null;
  laborCostIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'firstName' | '-firstName' | 'lastName' | '-lastName' | 'isEnabled' | '-isEnabled' | 'color' | '-color' | 'email' | '-email' | 'phoneNumber' | '-phoneNumber' | 'roles' | '-roles' | 'memberId' | '-memberId' | 'isPlatformAdmin' | '-isPlatformAdmin' | 'isSuperAdmin' | '-isSuperAdmin' | 'globalRolesCount' | '-globalRolesCount' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listUsers(http: HttpClient, rootUrl: string, params?: ListUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminUserDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listUsers.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('groupId', params.groupId, {});
    rb.query('laborCostIds', params.laborCostIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminUserDtoPage>;
    })
  );
}

listUsers.PATH = '/v0/adminUsers/users';
